import { UpdateOfficeServerRequest } from "../../../domain/repositories/ConfigRepository";

export const TRIGGER_UPDATE_OFFICE_SERVER = 'UPDATE_OFFICE_SERVER.TRIGGER';
export const UPDATE_OFFICE_SERVER_PENDING = 'UPDATE_OFFICE_SERVER.PENDING';
export const UPDATE_OFFICE_SERVER_SUCCESS = 'UPDATE_OFFICE_SERVER.SUCCESS';
export const UPDATE_OFFICE_SERVER_ERROR = 'UPDATE_OFFICE_SERVER.ERROR';

export const RESET_UPDATE_OFFICE_SERVER = 'UPDATE_OFFICE_SERVER.RESET';

export interface TriggerUpdateOfficeServer {
  type: typeof TRIGGER_UPDATE_OFFICE_SERVER;
  payload: {
    request: UpdateOfficeServerRequest;
  }
}

export interface UpdateOfficeServerPending {
  type: typeof UPDATE_OFFICE_SERVER_PENDING;
}

export interface UpdateOfficeServerSuccess {
  type: typeof UPDATE_OFFICE_SERVER_SUCCESS;
}

export interface UpdateOfficeServerError {
  type: typeof UPDATE_OFFICE_SERVER_ERROR;
}

export interface ResetUpdateOfficeServer {
  type: typeof RESET_UPDATE_OFFICE_SERVER;
}


export type UpdateOfficeServerActionType =
  | TriggerUpdateOfficeServer
  | UpdateOfficeServerPending
  | UpdateOfficeServerSuccess
  | UpdateOfficeServerError
  | ResetUpdateOfficeServer;


export interface UpdateOfficeServerState {
  updateOfficeServerPending: boolean;
  updateOfficeServerError: boolean;
}